"use client";

import { LazyEncapsulatedQuickAdd } from "@faire/deprecated-retailer-visitor-shared/components/QuickAdd/LazyEncapsulatedQuickAdd";
import { QuickAddProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { useFaireProtection } from "@faire/deprecated-retailer-visitor-shared/stores/domain/FaireProtection/useFaireProtection";
import React, { Suspense } from "react";

import { useCanQuickAdd } from "../../../../ComposableProductTile/__internal__/__internal__/useCanQuickAdd";
import { useTileInteractions } from "../TileInteractionsContextProvider";

export const QuickAddBase: React.FC<{
  data: QuickAddProps & { showOnHover: boolean };
  className?: string;
}> = ({ data, className }) => {
  const { overlayActions } = useTileInteractions();

  const { isBrandTokenForbidden } = useFaireProtection();
  const isFaireProtectionRestricted = isBrandTokenForbidden(
    data.brandToken ?? ""
  );

  const canQuickAddProduct = useCanQuickAdd(data.state, data.quickAdd);
  if (!canQuickAddProduct) {
    return null;
  }

  return (
    <div
      className={className ? className : "absolute right-0"}
      data-test-id="composable-quick-add"
    >
      <Suspense fallback={null} key={`${data.productToken}-suspense`}>
        <LazyEncapsulatedQuickAdd
          key={`${data.productToken}-encapsulated-quick-add`}
          productToken={data.productToken}
          quickAdd={data.quickAdd}
          brandToken={data.brandToken}
          onQuickAddClick={overlayActions?.onQuickAddClick}
          onQuickAddSubmit={overlayActions?.onQuickAddSubmit}
          onChooseOption={overlayActions?.onChooseOptionClick}
          onChooseOptionQuantityUpdate={
            overlayActions?.onChooseOptionQuantityUpdateSubmit
          }
          disableQuickAddWithFaireProtectionTooltip={
            isFaireProtectionRestricted
          }
        />
      </Suspense>
    </div>
  );
};
